import React from "react";
// import './TermsConditions.css';
import { ProfileBG } from "../../Assests/Assests";

const Refunds = () => {
  return (
    <div className="shipping-policy-container refund-container">
      <div className="image-container">
        {/* <img src={ProfileBG} alt="Shipping Bag" className="bag-image" /> */}
        <div className="image-text">Refund Policy</div>
      </div>
      <div className="shipping-text">
        {/* <h3>Refund Policy</h3> */}
        <p>
        All sales are final. Returns will only be accepted for size errors, and only if the item is unworn, unwashed, and the seal tags remain unbroken. Please ensure the tags are intact and the item is in its original condition before making your purchase.
        </p>
      </div>
    </div>
  );
};

export default Refunds;
